import React from 'react';
import Logo from './Logo';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <Logo size={36} />
              <span className="footer__logo-text">Hirexio</span>
            </div>
            <p className="footer__tagline">
              Recruiting done right.
            </p>
          </div>
          <div className="footer__links">
            <button onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}>
              Services
            </button>
            <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
              Contact
            </button>
          </div>
        </div>
        <div className="footer__bottom">
          <span>Copyright &copy; {new Date().getFullYear()} Hirexio. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
